import Notification from '../base/notification'
import * as constants from '../../utils/constants'

const PREFIX_NOTICE_CLASS = `${constants.PREFIX_CLASS}notice`
const PREFIX_KEY = 'aid_notice_key_'

let top = 24
let defaultDuration = 4.5
let noticeInstance
let name = 1
const iconTypes = {
  info: 'information-outline',
  success: 'check-circle-outline',
  warning: 'alert-outline',
  danger: 'close-circle-outline'
}
function getNoticeInstance() {
  noticeInstance =
    noticeInstance ||
    Notification.newInstance({
      prefixCls: PREFIX_NOTICE_CLASS,
      styles: {
        top: `${top}px`,
        right: 0
      },
      type: 'notice'
    })
  return noticeInstance
}
function notice(type, options) {
  const title = options.title || ''
  const desc = options.desc || ''
  const noticeKey = options.name || `${PREFIX_KEY}${name}`
  const onClose = options.onClose || function() {}
  const duration =
    options.duration === 0 ? 0 : options.duration || defaultDuration
  name++
  let instance = getNoticeInstance()
  let content
  const withDesc = desc === '' ? '' : ` ${PREFIX_NOTICE_CLASS}-with-desc`
  if (type === 'normal') {
    content = `
            <div class="${PREFIX_NOTICE_CLASS}-custom-content ${PREFIX_NOTICE_CLASS}-with-normal${withDesc}">
                <div class="${PREFIX_NOTICE_CLASS}-title">${title}</div>
                <div class="${PREFIX_NOTICE_CLASS}-desc">${desc}</div>
            </div>
        `
  } else {
    const iconType = iconTypes[type]
    content = `
            <div class="${PREFIX_NOTICE_CLASS}-custom-content ${PREFIX_NOTICE_CLASS}-with-icon ${PREFIX_NOTICE_CLASS}-with-${type}${withDesc}">
                <span class="${PREFIX_NOTICE_CLASS}-icon ${PREFIX_NOTICE_CLASS}-icon-${type}">
                    <i class="${constants.CLASS_MAIN} ${
  constants.CLASS_MAIN
}-${iconType}"></i>
                </span>
                <div class="${PREFIX_NOTICE_CLASS}-title">${title}</div>
                <div class="${PREFIX_NOTICE_CLASS}-desc">${desc}</div>
            </div>
        `
  }
  instance.notice({
    name: noticeKey.toString(),
    duration: duration,
    styles: {},
    transitionName: 'move-up',
    content: content,
    onClose: onClose,
    closable: true
  })
}
export default {
  open(options) {
    return notice('normal', options)
  },
  info(options) {
    return notice('info', options)
  },
  success(options) {
    return notice('success', options)
  },
  warning(options) {
    return notice('warning', options)
  },
  danger(options) {
    return notice('danger', options)
  },
  config(options) {
    if (options.top) {
      top = options.top
    }
    if (options.duration || options.duration === 0) {
      defaultDuration = options.duration
    }
  },
  close(name) {
    if (name) {
      name = name.toString()
      if (noticeInstance) {
        noticeInstance.remove(name)
      }
    } else {
      return false
    }
  },
  destroy() {
    let instance = getNoticeInstance()
    noticeInstance = null
    instance.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/components/notice/index.js